var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuminaryEdgeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8945_352",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5918,
    cy: 17.5918,
    r: 17.5918,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8945_352)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.22273,
    cy: -3.12414,
    r: 14.5952,
    transform: "rotate(-22 9.22273 -3.12414)",
    fill: "#1B0B3B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.9625,
    cy: 38.3071,
    r: 14.5952,
    transform: "rotate(-22 25.9625 38.3071)",
    fill: "#1B0B3B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -3.12297,
    cy: 25.9614,
    r: 14.5952,
    transform: "rotate(-22 -3.12297 25.9614)",
    fill: "#1B0B3B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.9244,
    cy: 8.27314,
    r: 14.5952,
    transform: "rotate(-22 37.9244 8.27314)",
    fill: "#1B0B3B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuminaryEdgeLogo);
export default __webpack_public_path__ + "static/media/Luminary-Edge-logo.29e2ea439fb438240a0f5acfbe8a77f8.svg";
export { ForwardRef as ReactComponent };